import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const satsukiPlugin = createPlugin({
  id: 'satsuki',
  routes: {
    root: rootRouteRef,
  },
});

export const SatsukiPage = satsukiPlugin.provide(
  createRoutableExtension({
    name: 'SatsukiPage',
    component: () => import('./components/App').then(m => m.App),
    mountPoint: rootRouteRef,
  }),
);
